import type { SearchArea } from './types.ts';

/**
 * „BLISKO DO…” — reguły miejsca wspólne dla strony wyników, kodeka zapisanego zestawu i przyszłej
 * funkcji `send-filter-alerts` (plan §1.18, E4.2). Czyste, zgodne z Deno.
 */

/** „Blisko do…” radius: 800 m in a straight line, „ok. 10 min pieszo” (plan §1.18, S5). No picker. */
export const PLACE_RADIUS_M = 800;

/**
 * ONE PLACE AT A TIME (plan §1.18): a new „Blisko do…” place replaces the previous one and
 * keeps every other area. `null` removes the place.
 */
export function zJednymMiejscem(areas: SearchArea[] | undefined, miejsce: SearchArea | null): SearchArea[] | undefined {
  const reszta = (areas ?? []).filter((a) => a.kind !== 'place');
  const wynik = miejsce && miejsce.kind === 'place' ? [...reszta, miejsce] : reszta;
  return wynik.length ? wynik : undefined;
}

/** A hand-edited link or document with two places keeps only the last one. */
export function normalizujMiejsca(areas: SearchArea[]): SearchArea[] {
  const ostatnie = [...areas].reverse().find((a) => a.kind === 'place') ?? null;
  return zJednymMiejscem(areas, ostatnie) ?? [];
}
